/**
 * @typedef Notification
 * @property {number} notification_id
 * @property {string} title
 * @property {string} body
 * @property {string?} read_at
 * @property {string} created
 * @property {boolean} isNew
 */

export default {
  /**
   * @type {Notification[]}
   */
  notifications: [],
  hasMore: false,
  nUnread: 0,
  isLoading: false,
  /**
   * @type {'unread' | 'all'}
   */
  mode: 'unread',
  isListOpen: false,
}
